import React from 'react';
import PropTypes from 'prop-types';
import Tile from './Tile.component';
import s from './TileSelection.module.scss';

/**
 * A component that renders multiple tiles. This component does not
 * hold any state. The parent component needs to hold the currently selected value.
 */
function TileSelection(props) {
  const {
    field,
    form,
    tileConfigs,
    additionalContent,
    className,
    noMinHeight,
    onNext,
  } = props;

  const { name, value } = field;
  /**
   * Wrapper for the on change function to allow connection to formik
   * @param {undefined} v the value of the tile
   * @returns {undefined}
   */
  const handleChange = (v) => {
    form.setFieldValue(name, v);
    if (onNext) {
      // values, formikProps

      setTimeout(() => {
        onNext(form.values, form);
      }, 0);
    }
  };

  let tileListClass = s.tileSelection;
  if (className) {
    tileListClass = `${tileListClass} ${className}`;
  }
  if (tileConfigs.length === 4) {
    tileListClass = `${tileListClass} ${s.tileCount4}`;
  }
  if (tileConfigs.length === 5) {
    tileListClass = `${tileListClass} ${s.tileCount5}`;
  }

  return (
    <div className={noMinHeight ? null : s.wrapper}>
      <ol className={tileListClass}>
        {tileConfigs.map((tileConfig, index) => (
          <li
            className={index !== tileConfigs.length - 1 ? s.tileWithMargin : ''}
            key={tileConfig.value}
          >
            <Tile
              name={name}
              label={tileConfig.label}
              value={tileConfig.value}
              iconComponent={tileConfig.iconComponent}
              checked={value === tileConfig.value}
              onChange={handleChange}
            />
          </li>
        ))}
      </ol>
      {additionalContent && (
        <div className={s.additionalContent}>{additionalContent}</div>
      )}
    </div>
  );
}

TileSelection.defaultProps = {
  additionalContent: null,
  className: '',
  noMinHeight: false,
  onNext: null,
};

TileSelection.propTypes = {
  /** Formik form object */
  form: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  /** Formik field object */
  field: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  /** An array with one config object per tile */
  tileConfigs: PropTypes.arrayOf(
    PropTypes.shape({
      /** React-intl id of the label text */
      label: PropTypes.string.isRequired,
      /** Value this tile represents  */
      value: PropTypes.string.isRequired,
      /** The name of the icon component to render, see icons/index.js for available icons */
      iconComponent: PropTypes.string.isRequired,
    })
  ).isRequired,
  /** */
  additionalContent: PropTypes.node,
  /** Class to apply to the wrapping div */
  className: PropTypes.string,
  /** Don't set a min height for use in a form */
  noMinHeight: PropTypes.bool,
  onNext: PropTypes.func,
};

export default TileSelection;
